const JSONLD_ATTR = "data-seo-jsonld";

export function clearJsonLd(): void {
  if (typeof document === "undefined") return;
  document
    .querySelectorAll(`script[${JSONLD_ATTR}]`)
    .forEach((el) => el.remove());
}

export function applyJsonLd(schemas: Record<string, unknown>[]): void {
  if (typeof document === "undefined") return;
  clearJsonLd();
  schemas.forEach((schema) => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.setAttribute(JSONLD_ATTR, "true");
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);
  });
}